module.exports = __webpack_public_path__ + "static/media/screen-proj-arch-diagnosis.c81cee2d.jpg";